import React from "react";
import { Dropdown, Form } from "semantic-ui-react";
import { mapToSelect } from "@common/components/helpers/forms";

const Filters = (props) => {
  const longTermOptions = [
    { key: "24 Hours", text: "24 Hours", value: 0 },
    { key: "7 Days", text: "7 days", value: 1 },
    { key: "28 Days", text: "28 Days", value: 2 },
  ];
  const shortTermOptions = [
    { key: "20 Minutes", text: "20 Minutes", value: 3 },
    { key: "1 Hour", text: "1 Hour", value: 4 },
    { key: "3 Hours", text: "3 Hours", value: 5 },
    { key: "24 Hours", text: "24 Hours", value: 0 },
    { key: "7 Days", text: "7 days", value: 1 },
    { key: "28 Days", text: "28 Days", value: 2 },
  ];

  const options = !props.shortTerm ? longTermOptions : shortTermOptions;

  const yesOrNo = [
    { key: "Yes", text: "Yes", value: true },
    { key: "No", text: "No", value: false },
  ];

  const {
    dataType,
    dataTypes,
    onChange,
    disabled,
    periodType,
    hideShowEvents,
    showEvents,
    showAlertFilter = false,
    includeNonAlerts,
  } = props;

  return (
    <Form widths="equal">
      <Form.Group>
        {dataTypes && (
          <Form.Field className="mb-1">
            <label>Data Type</label>
            <Dropdown
              selection
              name="dataType"
              value={dataType}
              disabled={disabled}
              options={mapToSelect(dataTypes)}
              onChange={onChange}
            />
          </Form.Field>
        )}
        <Form.Field className="mb-1">
          <label>Last</label>
          <Dropdown
            selection
            name="periodType"
            value={periodType}
            disabled={disabled}
            options={options}
            onChange={onChange}
          />
        </Form.Field>
        {hideShowEvents !== true && (
          <Form.Field className="mb-1">
            <label>Show Events</label>
            <Dropdown
              selection
              name="showEvents"
              value={showEvents}
              disabled={disabled}
              options={yesOrNo}
              onChange={onChange}
            />
          </Form.Field>
        )}
        {showAlertFilter === true && (
          <Form.Field className="mb-1">
            <label>Include Non Alerts</label>
            <Dropdown
              selection
              name="includeNonAlerts"
              value={includeNonAlerts}
              disabled={disabled}
              options={yesOrNo}
              onChange={onChange}
            />
          </Form.Field>
        )}
      </Form.Group>
    </Form>
  );
};

export default Filters;
